class ActivitiesSlider {
    constructor(element) {
        Object.defineProperty(this, "slider", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "prevArrow", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "nextArrow", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        this.slider = element.querySelector('.block-activities-list__slider');
        this.prevArrow = element.querySelector('.slick-slider-arrow-prev') ?? undefined;
        this.nextArrow = element.querySelector('.slick-slider-arrow-next') ?? undefined;
        if (this.slider) {
            jQuery(this.slider).slick({
                dots: false,
                infinite: true,
                slidesToScroll: 1,
                variableWidth: true,
                centerMode: true,
                rows: 0,
                lazyLoad: 'progressive',
                prevArrow: this.prevArrow,
                nextArrow: this.nextArrow,
            });
        }
    }
}
export default function activitiesSlider() {
    const activitiesSliders = document.querySelectorAll('.block-activities-list__slider-container');
    for (const element of activitiesSliders) {
        new ActivitiesSlider(element);
    }
}
